import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import logo from './airimg/9W.JPG'
import { kmtulogo } from './carrier-logo'
import Api from '../state/Api'
import { lazy } from 'react'
import { bookingsStore, configStore, contractsStore, loginStore } from '../state/CommonState'
import Utils from '../util/Utils'
import { LCL, OLCL, DLCL, Line, LCL1 } from '../components/circle-line'
import AirChargesClientView from './AirChargesClientView'
import airlineCodes from '../static-data/airlines'
import airlogoMap from './air-logo'

export default function AirScheduleComp(props) {
    const [showCharges, setShowCharges] = useState(false)
    useSnapshot(contractsStore)

    const rec = contractsStore.current
    if (!rec) return <></>
    let airlogo = airlogoMap[rec.airline.trim()]
    if(rec && rec.airline && rec.airline.trim().length>0){
        if(rec.airline.trim().length>2){
          airlogo = airlogoMap[rec.airline
            .substring(
              rec.airline.lastIndexOf("(") + 1,
              rec.airline.lastIndexOf(")")
            )
            .trim()]
        }
      }
    return (
        <div className="box">
            <div className="columns" style={{ fontSize: '0.8rem' }}>
                <div className="column is-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0px' }}>
                    {
                        airlogo ? <img src={airlogo} /> : rec.airline
                    }

                </div>
                <div className="column is-9">
                    <table className='schtable' style={{ width: '100%', textAlign: 'center' }}>
                        <tr>
                            <td></td>
                            <td>
                            </td>
                            <td colSpan={2}>
                                {
                                    (rec.transitTime!=undefined && Number(rec.transitTime)>0)?
                                    <>
                                    <div style={{ color: 'grey' }}>Air Transit Time</div>
                                    <div style={{ fontSize: '0.9rem' }}><strong>{rec.transitTime} days</strong></div>
                                    </>:<div style={{ color: 'grey' }}>Schedule Awaited</div>
                                }
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {rec.origin}
                            </td>
                            <td>
                                {rec.originAirport}

                            </td>
                            <td>
                            </td>
                            <td>
                            </td>
                            <td>
                            </td>
                            <td>{rec.destination}
                            </td>
                        </tr>
                        <tr>
                            <td><LCL left='1' /></td>
                            <td><LCL /></td>
                            <td><Line /></td>
                            <td><Line /></td>
                            <td><Line /></td>
                            <td><LCL right='1' /></td>
                        </tr>
                    </table>
                </div>
                <div className='column is-2' style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue)}</strong></div>
                    <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD, 'USD')}</div>
                    <div style={{ fontSize: '0.6rem', color: 'grey' }}>(Taxes, as Applicable)</div>
                    {
                        (!props.viewonly && rec.quoteStatus == 'ACCEPTED') ?
                            <button className='button is-rounded is-link is-small' onClick={() => {
                                Utils.checkBookingBlocked({
                                    rec,
                                    data: props.data,
                                    shipmentType: 'Air',
                                    onProceed: () => {
                                        bookingsStore.initialize()
                                        bookingsStore.current.schedule = props.data
                                        bookingsStore.current.contract = { ...rec }
                                        bookingsStore.current.contractNum = rec._id
                                        configStore.scheduleOrCarrierform = 'carrierform'
                                    }
                                })
                            }}>
                                Proceed to Booking
                            </button> : <></>
                    }
                </div>
            </div>
            <div className="columns" style={{ fontSize: '0.8rem' }}>
                {
                    (showCharges) ?
                        <button className='button is-warning is-small is-fullwidth' onClick={() => setShowCharges(false)}>
                            Hide Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-up"></i>
                            </span>
                        </button> :
                        <button className='button is-info is-small is-fullwidth' onClick={() => setShowCharges(true)}>
                            View Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-down"></i>
                            </span>
                        </button>
                }

            </div>
            {
                (showCharges) ?
                    <div className="columns" style={{
                        fontSize: '0.8rem',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <AirChargesClientView /> 
                    </div> : <></>
            }
        </div>
    )
}